import React from "react";
import './LegalPages.scss';

const CookiesPolicy = () => (
  <div className="legal-page">
    <h1>Politique de cookies</h1>
    <p>Dernière mise à jour : 7 août 2025</p>

    <p>
      Notre site utilise des cookies et traceurs pour :
    </p>
    <ul>
      <li>Garantir le fonctionnement du service (cookies essentiels)</li>
      <li>Mesurer l’audience (statistiques anonymes)</li>
      <li>Améliorer votre expérience utilisateur</li>
    </ul>

    <h2>Quels cookies utilisons-nous&nbsp;?</h2>
    <ul>
      <li>
        <strong>Cookies essentiels&nbsp;:</strong> nécessaires au fonctionnement du site (ex.&nbsp;: session)
      </li>
      <li>
        <strong>Cookies analytiques&nbsp;:</strong> mesure d’audience (Google Analytics, Matomo… si utilisé)
      </li>
      <li>
        <strong>Préférences&nbsp;:</strong> enregistrement de vos choix (langue, consentement)
      </li>
    </ul>

    <h2>Gestion de votre consentement</h2>
    <p>
      Lors de votre première visite, un bandeau vous propose&nbsp;:
    </p>
    <ul>
      <li>Accepter tous les cookies</li>
      <li>Refuser tous les cookies</li>
      <li>Personnaliser vos choix</li>
    </ul>
    <p>
      Vous pouvez modifier votre consentement à tout moment via le <strong>[lien « Gérer mes cookies » dans le pied de page]</strong>.
    </p>

    <h2>Données collectées via cookies</h2>
    <ul>
      <li>Données de navigation anonymisées</li>
      <li>Aucune donnée sensible ou de géolocalisation sans consentement explicite</li>
    </ul>

    <h2>Contact</h2>
    <p>
      Pour toute question, contactez-nous à <strong>sbdev42@gmail.com</strong>.
    </p>
  </div>
);

export default CookiesPolicy;
